<template>
    <v-card
            flat
            v-if="content.length !==0"
    >
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container
                v-for="(i, index) in content" :key="index"
                class="thank-you-pages signup-container"
        >
            <v-card-text class="tab-title">
                <h2 
                    class="title mb-2"
                    v-text="'Thank You Page - ' + removeUnderScore(i.type)">
                </h2>
            </v-card-text>
            <v-card-text class="tab-title"><p class="subtitle-editor">Thank You Page Content</p></v-card-text>
            <vue-editor
                    ref="myTextEditor"
                    v-model="i.content"
                    :id="'editor_' + index"
                    :editorToolbar="customToolbar"
                    class="quill-editor-tabs">
            </vue-editor>
            <v-btn
                    :color="savedButtons[index].color"
                    class="btns-onboard"
                    type="submit"
                    @click.native="postContent(i.type,i.content,index)"
                    :loading="savedButtons[index].loading"
                    :disabled="savedButtons[index].loading"
                    transition="fade-transition">
                {{savedButtons[index].text}}
            </v-btn>
            <button
                    class="reset-btn"
                    v-on:click="resetContent(index)"
            >Reset
            </button>
        </v-container>
    </v-card>
    <v-card flat v-else>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container v-if="loading == false" class="onboarding-error-message">
            <h1>!</h1><h5>Something went wrong!</h5><h5>Please refresh your browser and try again.</h5>
        </v-container>
    </v-card>
</template>

<script>
    import {VueEditor} from 'vue2-quill-editor';
    import ApiService from "../../../common/api.service";

    export default {
        props: ['orgid'],
        data() {
            return {
                content: [],
                customToolbar: [
                    ['bold', 'italic', 'underline', 'link'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ],
                loading: true,
                savedButtons: [
                    {color: "cyan darken-3", text: 'Save Changes', loading: false},
                    {color: "cyan darken-3", text: 'Save Changes', loading: false},
                    {color: "cyan darken-3", text: 'Save Changes', loading: false}
                ]
            }
        },
        beforeMount() {
            this.getContent()
        },
        components: {
            VueEditor
        },
        methods: {
            getContent() {
                ApiService.get(`/client_on_boarding_setup/thank_you_pages/${this.orgid}`)
                    .then(response => {
                        let data = response.data;
                        this.content = data.thank_you_pages;
                        this.loading = false;

                    })
                    .catch(error => {
                        this.error = error;
                        console.log(error);
                    });
            },
            postContent(type, content, index) {
                this.savedButtons[index].loading = true;
                let data = {
                    organization_form_id: this.orgid,
                    type: type,
                    content: content,
                };
                ApiService.put(`/client_on_boarding_setup/thank_you_page`, data)
                    .then(response => {
                        this.savedButtons[index].color = "success";
                        this.savedButtons[index].text = "Changes Saved";
                        this.savedButtons[index].loading = false;

                        setTimeout(() => {
                            this.savedButtons[index].color = "cyan darken-3";
                            this.savedButtons[index].text = "Save Changes";
                            this.savedButtons[index].loading = false;
                        }, 3000);
                    })
                    .catch(error => {
                        this.savedButtons[index].color = "red";
                        this.savedButtons[index].text = "Save Unsuccessful";
                        this.savedButtons[index].loading = false;
                        setTimeout(() => {
                            this.savedButtons[index].color = "cyan darken-3";
                            this.savedButtons[index].text = "Save Changes";
                            this.savedButtons[index].loading = false
                        }, 5000);
                    });
            },
            removeUnderScore(str) {
                for (let i in str) {
                    str = str.replace('_', ' ');
                }
                return str = str.replace(/\w\S*/g, function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            },
            resetContent(index) {
                this.content[index].content = this.content[index].default_content
            }
        }
    }
</script>
<style>
</style>
